import { useEffect } from 'react'
import ReactTooltip from 'react-tooltip'
import { QUANTITY } from '../consts';
import { formatPrice } from '../../helpers/common';
import { CurrencyDollarIcon } from '@heroicons/react/24/solid';

export const POSidebarSummaryItems = ({
    summaryItems,
    testId,
}) => {
    useEffect(() => {
        ReactTooltip.rebuild()
    }, [])

    // Filter items for the 2x2 grid (top 4 items)
    const topLeftItem = summaryItems.find(item => item.gridPosition === 'top-left');
    const topRightItem = summaryItems.find(item => item.gridPosition === 'top-right');
    const bottomLeftItem = summaryItems.find(item => item.gridPosition === 'bottom-left');
    const bottomRightItem = summaryItems.find(item => item.gridPosition === 'bottom-right');
    
    // Items below the grid
    const belowGridItems = summaryItems.filter(item => item.gridPosition === 'below-grid');

    const renderSummaryItem = (item, index) => {
        if (!item) return null;
        
        const additionalParams = {}
        if (item.withTooltip) {
            additionalParams['data-for'] = `tooltip-quantity_${index}`
            additionalParams['data-tip'] = true
        }
        
        // Set background color based on grid position
        let bgColor = "bg-gray-50"; // default
        if (item.gridPosition === 'top-left') bgColor = "bg-[#e3f7e9]"; // Total Paid — prototype --eadin-paid
        else if (item.gridPosition === 'top-right') bgColor = "bg-[#eef6fb]"; // Shipping — prototype --eadin-shipping-bg
        else if (item.gridPosition === 'bottom-left') bgColor = "bg-[#f4f4f5]"; // Total Value — prototype muted
        else if (item.gridPosition === 'bottom-right') bgColor = "bg-[#fdeeec]"; // Total Owed — prototype --eadin-owed-bg

        
        return (
            <div 
                key={index} 
                className={`${bgColor} p-3.5 rounded-lg relative`}
            >
                {item.withTooltip && (
                    <>
                        <div 
                            className="h-4 w-4 absolute right-1 bottom-1 bg-black rounded-full flex items-center justify-center text-white"
                            {...additionalParams}
                        >
                            <span className="italic text-xs font-bold">i</span>
                        </div>
                        <ReactTooltip 
                            id={`tooltip-quantity_${index}`} 
                            html={true}
                            effect='solid'
                            className={item.tooltipAlign ? item.tooltipAlign : 'text-right'}
                        >
                            {item.tooltipText}
                        </ReactTooltip>
                    </>
                )}
                
                {/* Header with title and main value */}
                <div className="flex justify-between items-center">
                    <div className="flex items-center gap-1.5 text-[15px] font-semibold whitespace-nowrap">
                        {item.icon}
                        {item.label}
                    </div>
                    <div className={`text-xl font-bold tabular-nums ${item.additionalClass || ""}`}>
                        {item.label !== QUANTITY ? `$${formatPrice(item.value)}` : item.value}
                    </div>
                </div>
                
                {/* Line items */}
                {item.lineItems && item.lineItems.length > 0 && (
                    <div className="mt-2 space-y-1 text-sm">
                        {item.lineItems.map((lineItem, idx) => (
                            <div key={idx} className="flex justify-between gap-2">
                                <span className="text-gray-500">{lineItem.label}</span>
                                <div className="flex flex-col">
                                    <span className={`tabular-nums font-medium text-right whitespace-nowrap ${lineItem.additionalClass || ""}`}>
                                        {lineItem.value}
                                        {lineItem.compareValue && (<span className="text-gray-500 font-normal"> / {lineItem.compareValue}</span>)}
                                    </span>
                                    {lineItem.subLabel && <span className="text-[10px] text-subLine self-end">from {lineItem.subLabel}</span>}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                
                {/* For backwards compatibility with old format */}
                {item?.subValue && !item.lineItems && (
                    <>
                        <small className={`text-l ${item.additionalClass || ""}`}>${formatPrice(item.subValue)} {item?.subValueSufix ? item?.subValueSufix : ""}</small>
                        {item?.subLabel && (<div className={`text-sm text-gray-500`}>{item.subLabel}</div>)}
                    </>
                )}
            </div>
        )
    }

    return (
        <div className="mb-6" data-testid={testId}>
            {/* 2x2 Grid */}
            <div className="grid grid-cols-1 min-[480px]:grid-cols-2 gap-2.5 mb-4">
                {renderSummaryItem(topLeftItem, 0)}
                {renderSummaryItem(topRightItem, 1)}
                {renderSummaryItem(bottomLeftItem, 2)}
                {renderSummaryItem(bottomRightItem, 3)}
            </div>
            
            {/* Items below grid */}
            <div className="grid grid-cols-3 gap-2 mt-4">
                {belowGridItems.map((item, index) => renderSummaryItem(item, index + 4))}
            </div>
        </div>
    )
}